import React from "react";
//import PropTypes from "prop-types";
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { getTranslate } from "react-localize-redux";
import { getReceiverShipments, putReceiverShipment } from '../../actions/shipment'

// material-ui components
import withStyles from "material-ui/styles/withStyles";

import SweetAlert from "react-bootstrap-sweetalert";


// core components
import IconCard from "components/Cards/IconCard.jsx";
import RequirementsCard from "components/Cards/RequirementsCard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";
import Table from "components/Table/Table.jsx";
import Button from "components/CustomButtons/Button.jsx";

import SimpleForm from "components/SimpleForm/SimpleForm.jsx";

// material-ui icons
import Assignment from "@material-ui/icons/Assignment";
import Person from "@material-ui/icons/Person";
import Edit from "@material-ui/icons/Edit";


import locationsPageStyle from "assets/jss/material-dashboard-pro-react/views/locationsPageStyle.jsx";


class ReceiverShipments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shipments: [],
      alert: null,
      edit: {},
    };
    this.handleReceiverShipmentEditSubmit = this.handleReceiverShipmentEditSubmit.bind(this);
    this.handleReceiverShipmentEditChange = this.handleReceiverShipmentEditChange.bind(this);
    this.handleReceiverShipmentEditCancel = this.handleReceiverShipmentEditCancel.bind(this);
  }

  handleReceiverShipmentEditSubmit(){
    this.props.dispatchPutReceiverShipment(this.props.auth.user, this.state.edit)
    .then( res => {
      return this.props.dispatchGetReceiverShipments(this.props.auth.user);
    })
    .then( shipments => {
      this.setState({edit:{}});
      this.setState({shipments});
      this.setState({
        alert: (
          <SweetAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Good job!"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
          >
            You clicked the button!
          </SweetAlert>
        )
      });
    });     

  }  

  handleReceiverShipmentEditChange(e, stateName, type, stateNameEqualTo){
    let value = e.target.value;
    if(e.target.type==="checkbox"){
      value = e.target.checked;
    }
    this.setState({edit:{ ...this.state.edit, [e.target.name]: value }});
    
  }

  handleReceiverShipmentEditCancel(){
      this.setState({edit:{}});    
  }

  handleTableAction(action, id){
    if(action==="edit"){
      var item = this.state.locations.find(function(i) {
        return i.id === id;
      });
      item.available = (item.available===1)?true:false;
      this.setState({editId: Date.now()});

      this.setState({edit:item});
    }
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }

  componentDidMount() {
    this.props.dispatchGetReceiverShipments(this.props.auth.user)
    .then( shipments => {
      this.setState({shipments});
    });   
  }
  render() {
    const {  translate, classes } = this.props;

    var shipmentTableData = [];
    if(this.state.shipments.length>0){
      this.state.shipments.map((prop,key)=>{
        
        let fillButtons = [
          { color: "info", icon: Person, action:"view" },
          { color: "success", icon: Edit, action: "edit" },
        ].map((button, buttonKey) => {
          return (
            <Button color={button.color} customClass={classes.actionButton} onClick={() => this.handleTableAction(button.action, prop.id)} key={buttonKey}>
              <button.icon className={classes.icon} />
            </Button>
          );
        });
        shipmentTableData.push([prop.id, prop.shipmentTrackingCode, prop.location, prop.customer, fillButtons]);
        return false;
      });
    }

    return (
      <div>
        <GridContainer>
          {this.state.alert}        
          <ItemGrid xs={12} sm={12} md={6}>
            <RequirementsCard content={translate("requirements.receiver_shipments.content")} />
          </ItemGrid>                
          <ItemGrid xs={12} sm={12} md={6}>
            <IconCard
              icon={Assignment}
              iconColor="rose"
              title="My Inbound Shipments"
              content={
                <Table
                  tableHead={[
                    "Id",
                    "Tracking Code",
                    "Location",
                    "Customer",
                    "Actions"
                  ]}
                  tableData={shipmentTableData}
                />
              }
            />
          </ItemGrid>
          <ItemGrid xs={12} sm={12} md={6}>
            <IconCard
              icon={Assignment}
              iconColor="rose"
              title="Horizontal Form"
              content={
                <form>
                  {this.state.edit.id?(
                    <div>
                      <GridContainer>
                        <SimpleForm handler={this.handleReceiverShipmentEditChange} editId={this.state.editId} state={this.state.edit} classes={classes} />
                      </GridContainer>

                      <GridContainer justify="flex-end">
                        <ItemGrid xs={12} sm={12} md={6}>
                          <Button color="rose" onClick={this.handleReceiverShipmentEditSubmit}>Submit</Button>
                        </ItemGrid>
                        <ItemGrid xs={12} sm={12} md={6}>
                          <Button onClick={this.handleReceiverShipmentEditCancel}>Cancel</Button>
                        </ItemGrid>
                      </GridContainer>
                    </div>
                  ):""}
                </form>
              }
            />
          </ItemGrid>                     
        </GridContainer>
      </div>
    );
  }
}


const mapDispatchToProps = {
  dispatchPutReceiverShipment: (user, data) => putReceiverShipment(user, data),
  dispatchGetReceiverShipments: (user) => getReceiverShipments(user),
}

const mapStateToProps = (state, props) => {
  return {
    translate: getTranslate(state.localize),
    auth: state.auth,
  }
}


export default compose(
  withStyles(locationsPageStyle),
  connect(mapStateToProps, mapDispatchToProps)
)(ReceiverShipments);




// WEBPACK FOOTER //
// ./src/views/Receiver/ReceiverShipments.jsx